import { action, payload } from "ts-action";
import { GlobalFetchPartition } from "./reducer";

export const requestFetchGlobalPartition = action(
  "GLOBAL FETCH > REQUEST",
  payload<{ partition: GlobalFetchPartition }>()
);

export const receiveFetchGlobalPartition = action(
  "GLOBAL FETCH > RECEIVE",
  payload<{ partition: GlobalFetchPartition }>()
);

export const errorFetchGlobalPartition = action(
  "GLOBAL FETCH > error",
  payload<{ partition: GlobalFetchPartition }>()
);
